export default "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgIi9hc3NldHMvbG9nby5kMGM5ZmJlMy5jOTZlMjI3Yi0yZGYzLTQ4YmUtYTU0MS1iMDhmMjQ1ODI3MGUucG5nIjs="